import { render, staticRenderFns } from "./RInputAddress.vue?vue&type=template&id=cd0ff0a2&"
import script from "./RInputAddress.vue?vue&type=script&lang=js&"
export * from "./RInputAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports